<script>
  import { router } from '@inertiajs/svelte'
  
  let { alert = null } = $props();
  
  let code = $state('');
  
  function submit(event) {
    event.preventDefault();
    router.post('/two_factor_authentication/challenge/recovery_codes', {
      code
    });
  }
</script>

<div class="recovery-challenge-container">
  {#if alert}
    <p class="alert">{alert}</p>
  {/if}

  <form onsubmit={submit}>
    <div class="form-group">
      <label for="code" class="form-label">
        <h1>OK, enter one of your recovery codes below:</h1>
      </label>
      <!-- svelte-ignore a11y_autofocus -->
      <input 
        id="code" 
        type="text" 
        bind:value={code} 
        required 
        autofocus 
        autocomplete="off"
        class="form-input" 
      />
    </div>
    
    <div class="form-actions">
      <button type="submit" class="continue-button">Continue</button>
    </div>
  </form>
  
  <div class="recovery-help">
    <p>To access your account, enter one of the recovery codes (e.g., xxxxxxxxxx) you saved when you set up your two-factor authentication device.</p>
  </div>
</div>

<style>
  .recovery-challenge-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  .alert {
    color: #b91c1c;
    margin-bottom: 1rem;
    padding: 0.5rem;
    background-color: #fee2e2;
    border-radius: 0.375rem;
  }
  
  .form-group {
    margin-bottom: 1.5rem;
  }
  
  .form-label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }
  
  .form-input {
    width: 100%;
    max-width: 300px;
    padding: 0.625rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1.125rem;
    letter-spacing: 0.1em;
    font-family: monospace;
  }
  
  .form-actions {
    margin-top: 1.5rem;
  }
  
  .continue-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .continue-button:hover {
    background-color: #065f46;
  }
  
  .recovery-help {
    margin-top: 2rem;
    padding: 1rem;
    background-color: #f3f4f6;
    border-radius: 0.375rem;
    font-size: 0.9rem;
    color: #4b5563;
  }
</style>